import gql from 'graphql-tag';

export const addStudentToCourseMutation = gql`
  mutation addStudentToCourse($userId: String!, $courseId: String!) {
    addStudentToCourse(userId: $userId, courseId: $courseId)
  }
`;
